import { Navigate } from "react-router";

import { useUserContext } from "sj-ui-toolkit/src/atlas/contexts/User/UserContextProvider";

import AspenChatBeta from "./AspenChatBeta";

export default function AspenChatPage() {
  const { isTenantAdmin } = useUserContext();

  if (!isTenantAdmin) {
    return <Navigate to="/" replace />;
  }

  return <AspenChatBeta />;
}
